import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { currentPageReportTemplate, onPageChange, paginatorTemplate } from "../../../utilities/TableUtil";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";
import Iframe from "react-iframe";

export default function P233List_2({ dataTable, setheadlerInpusText }) {
    const textAndInputCulumn = (rowData, checkColumn, titleShow, onChangeInputext, maxLength, inputnme) => {
        const data = { ...rowData };
        const datavalue = data[`${checkColumn}`];

        return (
            <React.Fragment>
                <span className="p-column-title">{titleShow}</span>
                <div className="p-fluid p-formgrid p-grid">
                    <div className={data.index === 8 ? "p-field p-col-12 p-md-1" : "p-field p-col-12 p-md-12"}>{datavalue && datavalue !== "" && datavalue !== "null" ? datavalue : "-"}</div>
                    {rowData.itemDetail != undefined && rowData.itemDetail !== null && (
                        <div className="p-field p-col-12 p-md-6">
                            <InputText id="otherDesc" type="text" maxLength={maxLength} value={rowData != "" ? rowData[inputnme] : ""} onChange={(e) => onChangeInputext(e.target.value, rowData, inputnme)} />
                        </div>
                    )}
                </div>
            </React.Fragment>
        );
    };

    const inputNumberColumn = (rowData, inputValue, setInputValue, placeholder, titleShow, inputnme, maxLenht = 99999999999, digits = 2) => {
        let data = { ...rowData };
        const _dis = () => {
            return rowData.index > 3 ? false : true;
        };
        return (
            <React.Fragment>
                <span className="p-column-title">{titleShow}</span>
                <InputNumber
                    value={inputValue.length > 0 ? inputValue[data.index][inputnme] : ""}
                    mode="decimal"
                    onValueChange={(e) => {
                        setInputValue(e.value, rowData, inputnme);
                    }}
                    style={{ width: "100%" }}
                    // useGrouping={false}
                    // max={99999999999}
                    minFractionDigits={digits}
                    maxFractionDigits={digits}
                    placeholder={placeholder}
                    disabled={_dis()}
                />
            </React.Fragment>
        );
    };

    const footer = () => {
        let sum = 0;

        dataTable.forEach((item, index) => {
            // if (index > 0 && index < 6) sum -= item.itemValue;

            // if (index > 5) sum += item.itemValue;
            if (index === 8) sum = item.total;
        });

        return (
            <div className="p-grid">
                <div className="p-col-12 p-md-12"></div>
                <div className="p-grid" style={{ paddingLeft: 15, paddingTop: 5 }}>
                    <h5 style={{ marginBottom: 0, paddingTop: 7 }}>
                        <b>ยอดรวม (</b>
                    </h5>
                    {dataTable.map((item, index) => {
                        let str = "-";
                        if (index > 4) {
                            str = "+";
                        }
                        if (index > 0) {
                            return (
                                <>
                                    <div style={{ marginLeft: 5, marginTop: 5, backgroundColor: "white", width: 25, height: 25, borderRadius: 20, borderColor: "#000", border: `2px solid #000`, textAlign: "center" }}>
                                        <h5>
                                            <b>{index + 1}</b>
                                        </h5>
                                    </div>
                                    <div style={{ paddingTop: 5, paddingLeft: 5, textAlign: "center" }}>
                                        <h5>{index === 8 ? <b>{") = "}</b> : <b>{str}</b>}</h5>
                                    </div>
                                </>
                            );
                        }
                    })}

                    <InputText style={{ marginLeft: 5 }} id="invoiceNo" className="p-invalid" type="text" value={sum} disabled={true} />
                </div>
            </div>
        );
    };

    return (
        <div className="datatable-responsive-modify">
            <div className="card">
                <DataTable footer={footer()} value={dataTable} dataKey="id" currentPageReportTemplate={currentPageReportTemplate()} emptyMessage="ไม่พบข้อมูล" className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify" selectionMode="single">
                    <Column field="itemDesc" header="รายการ" body={(e) => textAndInputCulumn(e, "itemDesc", "รายการ", setheadlerInpusText, 20, "itemDetail")} style={{ textAlign: "center", width: "20%" }} bodyStyle={bodyStyle.TXT_LEFT} />
                    <Column field="itemValue" header="จำนวนบาท (บาท)" body={(e) => inputNumberColumn(e, dataTable, setheadlerInpusText, "", "จำนวนบาท (บาท)", "itemValue", 9999, 2)} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                </DataTable>
            </div>
        </div>
    );
}
